import { StructureSelectionRequest } from './../../../../../common/structure-selection/structure-selection.model';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StationGroup } from '../../../../../client/model/station-group';
import { StructureSelctionFilter, StructureSelection, StructureSelectionScope } from '../../../../../common/structure-selection/structure-selection.model';
import { MovementOrderDetails } from '../../movement-orders.model';

@Component({
    selector: 'app-movement-order-rerouting-dialog',
    templateUrl: './movement-order-rerouting-dialog.component.html',
    styleUrls: ['./movement-order-rerouting-dialog.component.scss'],
    standalone: false
})
export class MovementOrderReroutingDialogComponent {


  confirmEnabled = true;
  movementOrderDetails: MovementOrderDetails;

  stationGroups: Array<StationGroup>;
  selectedStationGroup: StationGroup = null;
  structureSelectionValid = false;

  selection: StructureSelection;
  structureSelectionRequest: StructureSelectionRequest;

  scope: StructureSelectionScope;

  constructor(
    private dialog: MatDialogRef<MovementOrderReroutingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.movementOrderDetails = this.data.movementOrderDetails;


    // TODO
    this.structureSelectionRequest = new StructureSelectionRequest({
      scope: StructureSelectionScope.STATION,
      filter: StructureSelctionFilter.WAITING_AREA,
	  fixedStationSetId: this.movementOrderDetails.targetStationSetId,
      selection: new StructureSelection({ stationSetId: this.movementOrderDetails.targetStationSetId })
    });


  }

  public confirmDialog() {
    this.dialog.close(this.selection.stationId);
  }

  public cancelDialog() {
    this.dialog.close(null);
  }

  private updateEnablement() {
    this.confirmEnabled = this.selection && this.selection.stationSetId === this.movementOrderDetails.targetStationSetId
  }

  handleSelectionChange(selection: StructureSelection) {
    this.selection = selection;
    this.updateEnablement();
  }

}
